export default __webpack_public_path__ + "static/media/Cruz.047c3847.svg";